import { useEffect, useState } from 'react'

export const useFileContent = (url: string) => {
  const [content, setContent] = useState<string>('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [isIframe, setIsIframe] = useState(false)

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true)
      setError(null)

      if (!url) {
        setError('No URL available')
        setLoading(false)
        return
      }

      const urlIsPdf = url.toLowerCase().includes('.pdf')
      const urlIsDocx = url.toLowerCase().includes('.docx')

      if (urlIsPdf || urlIsDocx) {
        setLoading(false)
        setIsIframe(true)
        return
      }

      try {
        const response = await fetch(url)
        if (!response.ok) {
          throw new Error(`Failed to fetch content: ${response.statusText}`)
        }

        const contentType = response.headers.get('content-type')
        if (
          contentType?.includes('pdf') ||
          contentType?.includes('docx') ||
          contentType?.includes('vnd.openxmlformats-officedocument.wordprocessingml.document')
        ) {
          setLoading(false)
          setIsIframe(true)
          return
        }

        const text = await response.text()
        setContent(text)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load content')
      } finally {
        setLoading(false)
      }
    }

    fetchContent()
  }, [url])

  return { content, loading, error, isIframe }
}
